import { logger } from '.';
import { errorMessage } from '../consts';

/**
 * Format time to German local layout
 * @param time to be formatted
 */
export const formatTime = (time?: string): string => {
	if (!time) {
		logger(`formatTime: attempted to format ${time} as string`);
		return `${errorMessage}\nformatTime`;
	} else {
		return new Date(time).toLocaleTimeString('de-DE');
	}
};
